import {useReducer} from 'react'
import {CatalogsContext} from './CatalogsContext'
import {catalogReducer} from './catalogReducer'
import {types} from './types'
import {getAllCatalogs} from '../../services/catalog.service'
import {normalizeHomeCatalogs} from './catalogVisibility'

const initialState = {
	catalogs: {},
	loading: false,
	errorMessage: null,
}

export const CatalogsProvider = ({children}) => {
	const [catalogsState, dispatch] = useReducer(catalogReducer, initialState)

	const allCatalogs = async () => {
		try {
			dispatch({
				type: types.request,
			})
			const response = await getAllCatalogs()

			if (response.status === 200) {
				dispatch({
					type: types.catalogs,
					payload: normalizeHomeCatalogs(response.data),
				})
			} else {
				dispatch({
					type: types.error,
					payload: response.data.response,
				})
			}
		} catch (error) {
			dispatch({
				type: types.error,
				payload: error?.toString(),
			})
		}
	}

	return (
		<CatalogsContext.Provider value={{catalogsState, allCatalogs}}>
			{children}
		</CatalogsContext.Provider>
	)
}
